var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.354 25C14.0591 25.6224 14.9853 26 15.9998 26C17.0142 26 17.9405 25.6224 18.6456 25M21.9998 12C21.9998 10.4087 21.3676 8.88258 20.2424 7.75736C19.1172 6.63214 17.5911 6 15.9998 6C14.4085 6 12.8824 6.63214 11.7571 7.75736C10.6319 8.88258 9.99977 10.4087 9.99977 12C9.99977 15.0902 9.22024 17.206 8.34944 18.6054C7.6149 19.7859 7.24763 20.3761 7.2611 20.5408C7.27601 20.7231 7.31463 20.7926 7.46155 20.9016C7.59423 21 8.19237 21 9.38863 21H22.6109C23.8072 21 24.4053 21 24.538 20.9016C24.6849 20.7926 24.7235 20.7231 24.7384 20.5408C24.7519 20.3761 24.3846 19.7859 23.6501 18.6054C22.7793 17.206 21.9998 15.0902 21.9998 12Z",
    stroke: "#0E0E0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.354 25C14.0591 25.6224 14.9853 26 15.9998 26C17.0142 26 17.9405 25.6224 18.6456 25M21.9998 12C21.9998 10.4087 21.3676 8.88258 20.2424 7.75736C19.1172 6.63214 17.5911 6 15.9998 6C14.4085 6 12.8824 6.63214 11.7571 7.75736C10.6319 8.88258 9.99977 10.4087 9.99977 12C9.99977 15.0902 9.22024 17.206 8.34944 18.6054C7.6149 19.7859 7.24763 20.3761 7.2611 20.5408C7.27601 20.7231 7.31463 20.7926 7.46155 20.9016C7.59423 21 8.19237 21 9.38863 21H22.6109C23.8072 21 24.4053 21 24.538 20.9016C24.6849 20.7926 24.7235 20.7231 24.7384 20.5408C24.7519 20.3761 24.3846 19.7859 23.6501 18.6054C22.7793 17.206 21.9998 15.0902 21.9998 12Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.354 25C14.0591 25.6224 14.9853 26 15.9998 26C17.0142 26 17.9405 25.6224 18.6456 25M21.9998 12C21.9998 10.4087 21.3676 8.88258 20.2424 7.75736C19.1172 6.63214 17.5911 6 15.9998 6C14.4085 6 12.8824 6.63214 11.7571 7.75736C10.6319 8.88258 9.99977 10.4087 9.99977 12C9.99977 15.0902 9.22024 17.206 8.34944 18.6054C7.6149 19.7859 7.24763 20.3761 7.2611 20.5408C7.27601 20.7231 7.31463 20.7926 7.46155 20.9016C7.59423 21 8.19237 21 9.38863 21H22.6109C23.8072 21 24.4053 21 24.538 20.9016C24.6849 20.7926 24.7235 20.7231 24.7384 20.5408C24.7519 20.3761 24.3846 19.7859 23.6501 18.6054C22.7793 17.206 21.9998 15.0902 21.9998 12Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRead);
export default __webpack_public_path__ + "static/media/notificationRead.4623e761fb000b74e84ff2afd2b0f606.svg";
export { ForwardRef as ReactComponent };